/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_Meta_TitleInputs */

const en_fw_tpl_meta_title = /** @type {(inputs: Fw_Tpl_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan templates — Bystep`)
};

const id_fw_tpl_meta_title = /** @type {(inputs: Fw_Tpl_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template rencana — Bystep`)
};

/**
* | output |
* | --- |
* | "Plan templates — Bystep" |
*
* @param {Fw_Tpl_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_meta_title = /** @type {((inputs?: Fw_Tpl_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_meta_title(inputs)
	return en_fw_tpl_meta_title(inputs)
});